import { Box, Tooltip } from "@material-ui/core";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Axios from "axios";
import { Loading } from "../../components/shared/loading";
import { Helmet } from "react-helmet";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import "bootstrap/dist/css/bootstrap.min.css";

import { useAdminStyles } from "../../components/admin/adminStyles";
import { AdminPageHeader } from "../../components/admin/AdminPageHeader";

import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import RemoveCircleOutlineIcon from "@material-ui/icons/RemoveCircleOutline";

const headKey = "qweqeasdj123n1jasndjn2j3njsdn12i891bdjsdu1283djsd1231231";
const $ = require("jquery");

export const AllTestimonials = () => {
  const classes = useAdminStyles();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);

  useEffect(() => {
    Axios.get("/api/gettestms", { headers: { headKey: headKey } }).then(
      (res) => {
        setData(res.data.data || []);
        setLoading(false);
        $(document).ready(function () {
          $("#testimonials_table").DataTable({
            destroy: true,
            scrollX: true,
          });
        });
      }
    );
  }, []);

  if (loading) return <Loading />;

  return (
    <div>
      <Helmet>
        <title>Testimonials - Admin | Arawinz Soft Solutions</title>
      </Helmet>

      <AdminPageHeader
        eyebrow="Manage"
        title="Testimonials"
        subtitle="Client testimonials shown on the public site."
      />

      <Box className={classes.tableWrap}>
        <table
          id="testimonials_table"
          className="display"
          style={{ width: "100%" }}
        >
          <thead>
            <tr>
              <th>ID</th>
              <th>Client</th>
              <th>Image</th>
              <th>Priority</th>
              <th>Status</th>
              <th>Added</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {data.map((da) => (
              <tr key={da.test_id}>
                <td>{da.test_id}</td>
                <td>
                  <div style={{ fontWeight: 600, color: "#1a1a1a" }}>
                    {da.test_name}
                  </div>
                  <div style={{ fontSize: "0.72rem", color: "#9b3b9b" }}>
                    {da.test_prof}
                  </div>
                </td>
                <td>
                  {da.test_image !== null ? (
                    <img
                      src={"/static/testms/" + da.test_image}
                      alt={da.test_name}
                      style={{ height: 56, width: 56, objectFit: "cover" }}
                    />
                  ) : (
                    <span style={{ color: "#9ca3af", fontSize: "0.74rem" }}>
                      No image
                    </span>
                  )}
                </td>
                <td>{da.test_priority}</td>
                <td>
                  {da.test_status === 1 ? (
                    <span className={`${classes.badge} ${classes.badgeActive}`}>
                      <CheckCircleOutlineIcon /> Active
                    </span>
                  ) : (
                    <span
                      className={`${classes.badge} ${classes.badgeInactive}`}
                    >
                      <RemoveCircleOutlineIcon /> Inactive
                    </span>
                  )}
                </td>
                <td>{da.test_date}</td>
                <td>
                  <Box className={classes.actionCell}>
                    <Tooltip title="Edit" arrow>
                      <Link
                        to={"/dash/editfeedback/" + da.test_id}
                        className={classes.iconBtn}
                        aria-label="Edit"
                      >
                        <EditOutlinedIcon />
                      </Link>
                    </Tooltip>
                  </Box>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </Box>
    </div>
  );
};
